import _ from 'lodash';

import { getRequest, postRequest } from '../../Common/network-call';
import {
  PORTAL_LOCALSTORAGE_ACCESS_KEY,
  SCRIPT_URI_ADDON,
  TABLE_URI_ADDON
} from '../../../constants/constant';
import { setInLocalDB } from '../../../reducers/localStorage';
import {
  SCRIPTS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';

export const GLOBAL_SEARCH = 'GLOBAL_SEARCH';
export const LATEST_GLOBAL_SEARCHES = 'LATEST_GLOBAL_SEARCHES';
export const SELECTED_GLOBAL_SEARCH = 'SELECTED_GLOBAL_SEARCH';

export const globalSearch = (session, searchkey = '', callback) => {
  let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.eventifyScript.globalSearch.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.eventifyScript.globalSearch.payload);
  postBody.eventid = session.eventid;
  postBody.searchkey = searchkey;
  if (session.userid != '') postBody.appuserid = session.userid;
  else delete postBody.appuserid;

  return dispatch => {
    dispatch({ type: GLOBAL_SEARCH, payload: {} });
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      res => {
        if (res.is_error) {
          callback({ success: 1, data: res });
        } else {
          let payloadObj = {
            // NOTE: keys are up-to-date with ALLOWED_FEATURE_KEYS, change with causion
            data: {
              speaker: { content: [], order: 1 },
              exhibitor: { content: [], order: 2 },
              news: { content: [], order: 3 },
              schedule: { content: [], order: 4 },
              sponsor: { content: [], order: 5 },
              notes: { content: [], order: 6 }
            }
          };
          let resResult = res.result;

          // exhibitors
          if (
            resResult.exhibitors &&
            resResult.exhibitors.status_code == 200 &&
            resResult.exhibitors.content &&
            !_.isEmpty(resResult.exhibitors.content.resource)
          ) {
            payloadObj.data.exhibitor.content =
              resResult.exhibitors.content.resource;
          }

          // news
          if (
            resResult.news &&
            resResult.news.status_code == 200 &&
            resResult.news.content &&
            !_.isEmpty(resResult.news.content.resource)
          ) {
            payloadObj.data.news.content = resResult.news.content.resource;
          }

          // notes was here
          let notesIdStr = '( ';
          if (
            resResult.notes &&
            resResult.notes.status_code == 200 &&
            resResult.notes.content &&
            !_.isEmpty(resResult.notes.content.resource)
          ) {
            // payloadObj.data.notes.content = resResult.notes.content.resource;

            // --- producing an id-arr for similar notes search resullts
            _.map(resResult.notes.content.resource, (item, index) => {
              if (index == resResult.notes.content.resource.length - 1) {
                notesIdStr += item.id + ' )';
              } else {
                notesIdStr += item.id + ', ';
              }
            });
          }

          // session
          if (
            resResult.session &&
            resResult.session.status_code == 200 &&
            resResult.session.content &&
            !_.isEmpty(resResult.session.content.resource)
          ) {
            payloadObj.data.schedule.content =
              resResult.session.content.resource;
          }

          // speaker
          if (
            resResult.speaker &&
            resResult.speaker.status_code == 200 &&
            resResult.speaker.content &&
            !_.isEmpty(resResult.speaker.content.resource)
          ) {
            payloadObj.data.speaker.content =
              resResult.speaker.content.resource;
          }

          // sponsors
          if (
            resResult.sponsors &&
            resResult.sponsors.status_code == 200 &&
            resResult.sponsors.content &&
            !_.isEmpty(resResult.sponsors.content.resource)
          ) {
            payloadObj.data.sponsor.content =
              resResult.sponsors.content.resource;
          }

          // api call for notes > related data, global search reducer handled accordingly
          if (notesIdStr != '( ') {
            dispatch(
              fetchGlobalSearchAssociatedNotes(session, notesIdStr, res => {
                if (res.success) payloadObj.data.notes.content = res.data;

                dispatch({ type: GLOBAL_SEARCH, payload: payloadObj });
                callback({ success: 2, data: payloadObj });
              })
            );
          } else {
            dispatch({ type: GLOBAL_SEARCH, payload: payloadObj });
            callback({ success: 2, data: payloadObj });
          }
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const clearGlobalSearch = () => {
  return dispatch => {
    dispatch({ type: GLOBAL_SEARCH, payload: {} });
    dispatch(selectGlobalSearchItem({}));
  };
};

export const globalSearchLatest = value => {
  // --- setting same in localStorage
  setInLocalDB({
    key: PORTAL_LOCALSTORAGE_ACCESS_KEY.globalsearch,
    value: value
  });

  return dispatch =>
    dispatch({ type: LATEST_GLOBAL_SEARCHES, payload: _.reverse(value) });
};

export const selectGlobalSearchItem = value => {
  return dispatch => {
    dispatch({ type: SELECTED_GLOBAL_SEARCH, payload: {} });
    dispatch({ type: SELECTED_GLOBAL_SEARCH, payload: value });
  };
};

export const clearSelectedGlobalSearchItem = () => {
  return dispatch => dispatch({ type: SELECTED_GLOBAL_SEARCH, payload: {} });
};

const fetchGlobalSearchAssociatedNotes = (session, idArray, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(id IN ${idArray})`
  );
  let related =
    'appuser_by_attendeeid,exhibitors_by_exhibitorid,sponsor_by_sponsorid,speaker_by_speakerid';

  let fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuserNotes}?related=${related}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res.resource });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};
